import React from 'react';
import ScheduleTourForm from '../components/ScheduleTourForm';
import * as appointmentsService from '../services/appointments';

export default class ScheduleTourFormContainer extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      desiredAppointmentDate: null,

      // The times that two trees offers appointments, which don't vary by day.
      potentialAppointmentTimes: null,

      // A hash of YYYY-MM-DD strings to an array of available appointment times.
      // All times are in local time, in a 24-h format, like "13:00" or "15:30".
      appointmentTimesForDate: {},

      // Any error that occur occurred loading the data.
      loadingError: undefined,
    };

    this.changeAppointmentDate = this.changeAppointmentDate.bind(this);
  }

  componentDidMount() {
    appointmentsService
      .getAvailableAppointmentTimes(
        this.state.desiredAppointmentDate.format('YYYY-MM-DD')
      )
      .then((times) => {
        this.setState({ potentialAppointmentTimes: times });
      })
      .catch((e) => {
        this.setState({ loadingError: e });
      });
  }

  changeAppointmentDate(appointmentDate) {
    this.setState({ desiredAppointmentDate: appointmentDate });

    // The user can reset the appointment date picker, making appointmentDate null.
    // In that case, don't try to fetch the available times for that date.
    if (appointmentDate == null) {
      return;
    }

    if (!this.state.appointmentTimesForDate[appointmentDate]) {
      this.setState({
        appointmentTimesForDate: {
          ...this.state.appointmentTimesForDate,
          [appointmentDate]: { isLoading: true },
        },
      });

      appointmentsService
        .getAvailableAppointmentTimes(appointmentDate.format('YYYY-MM-DD'))
        .then((times) => {
          this.setState({
            appointmentTimesForDate: {
              ...this.state.appointmentTimesForDate,
              [appointmentDate]: { times, isLoading: false },
            },
          });
        })
        .catch((e) => {
          this.setState({ loadingError: e });
        });
    }
  }

  render() {
    if (this.state.loadingError) {
      return <div role="alert">An error occurred. Try reloading the page.</div>;
    }
    return (
      <ScheduleTourForm
        utmParams={this.props.utmParams}
        desiredDate={this.state.desiredAppointmentDate}
        availableTimesForDate={
          this.state.appointmentTimesForDate[this.state.desiredAppointmentDate]
        }
        potentialAppointmentTimes={this.state.potentialAppointmentTimes}
        onChangeAppointmentDate={this.changeAppointmentDate}
      />
    );
  }
}



// WEBPACK FOOTER //
// ./client/containers/ScheduleTourFormContainer.js